import React from "react";
import FooterColumn from "./FooterColumn";
import SubscribeSection from "./SubscribeSection";
import FooterBottom from "./FooterBottom";

const Footer: React.FC = () => {
    const companyLinks = [
        { text: "About Us", to: "/about" },
        //{ text: "Our Instructors", to: "#" },
        { text: "Contact", to: "/contact" },
    ];

    const programLinks = [
        { text: "Programs", to: "/programs" },
        //{ text: "Online English", to: "#" },
        //{ text: "Classroom English", to: "#" },
    ];

    const resourceLinks = [
        { text: "English Tips", to: "#" },
        { text: "Study Abroad", to: "#" },
    ];

    return (
        <footer className="px-4 py-20 mx-auto w-full max-w-screen-xl font-['Montserrat']">
        <div className="grid grid-cols-[3fr_1fr_1fr_1fr] gap-20 max-md:grid-cols-2 max-sm:grid-cols-1">
            <div className="flex gap-4 items-start max-md:flex-col max-md:items-center">
                <img
                    src={`${process.env.REACT_APP_BASE_URL}/images/iExcel_English.png`}
                    alt="iExcel logo"
                    className="h-[120px] w-[140px]"
                />
                <p className="text-sm text-gray-600 max-w-2xl leading-relaxed max-md:text-center">
                    iExcel English International offers a comprehensive learning solution from expertly designed curriculum and engaging interactive lessons to advanced progress tracking and personalized support empowering every child to learn and excel in English with confidence.
                </p>
            </div>
            <FooterColumn title="Our Company" links={companyLinks} />
            <FooterColumn title="Our Programs" links={programLinks} />
            {/* <FooterColumn title="Resources" links={resourceLinks} />
            <SubscribeSection /> */}
        </div>
        <FooterBottom />
    </footer>

    );
};

export default Footer;
